import { usePutItem } from 'Features/HTTP/RequestHandlers';
import { useResponseHandler, useErrorHandler } from 'Features/HTTP/ResponseHandler';
import apiConfig from 'Application/configurations/apiConfig';
import IUpdateInventory from "./interfaces/IUpdateInventory";
import ILockInventory from './interfaces/ILockInventory';
import { useAccessTokens } from 'Features/Authentication';
import { useTranslation } from 'react-i18next';
import IOpenInventory from './interfaces/IOpenInventory';

function useUpdateInventory () {

    const { t } = useTranslation();
    const putItem = usePutItem();
    const responseHandler = useResponseHandler();
    const errorHandler = useErrorHandler();
    const getToken = useAccessTokens();
    const AccessAsUser = apiConfig.scopes.AccessAsUser;

    /** Create new inventory survey
     * @param {string} companyId - guid of the company
     * @param {string} surveyId - guid of the survey
     * @param {IUpdateInventory} surveyData - object which describes the survey
     **/
    const updateInventory = async (companyId: string = "", surveyId: string="", surveyData: IUpdateInventory | ILockInventory | IOpenInventory) => {

        const basePath = apiConfig.basePath;
        const companyEndpoint = apiConfig.endpoints.companies
        const surveyEndpoint = apiConfig.endpoints.inventories;
        const url = new URL(`${basePath}/${companyEndpoint}/${companyId}/${surveyEndpoint}/${surveyId}`);
        const accessToken = await getToken([AccessAsUser]);

        const options = {
            accessToken: accessToken,
            body: surveyData
        }

        try {

            const response = await putItem(url, options);
         
            return responseHandler(response, "useUpdateInventory", { operation: "update", messageHeader: t("features.inventory.savedSuccessfully"), hide: false });


        } catch (error: any) {

            let problemTitle = error && error.data && error.data.title ? error.data.title : "";
            let body = null;

            if (problemTitle === "Inventory.UpdatePermissionDenied") body = t('features.survey.updatePermissionDenied');
            if (problemTitle === "Company.CompanyDataAccessDenied") body = t('features.company.companyDataAccessDenied');
            if (problemTitle === "Company.NotExist") body = t('features.company.notExist');
            if (problemTitle === "UserAccount.NotExist") body = t('features.account.userAccountNotExist');
            if (problemTitle === "General.RequestorNotExist") body = t('features.survey.requestorNotExist');
            if (problemTitle === "Inventory.NotExist") body = t('features.survey.notExist');
            if (problemTitle === "Inventory.PermanentlyLocked") body = t('features.survey.permanentlyLocked');
            if (problemTitle === "Inventory.Closed") body = t('features.survey.closed');

            return errorHandler(error, "useUpdateInventory", { operation: "update", hide: false, messageBody: body });

        }

    }

    return { updateInventory }

}

export default useUpdateInventory;
